import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
// import Button from 'react-bootstrap/Button';
import {
  Mensaje,
  // MensajeCapcha, MensajeSiNo
} from "../components/mensajes";

import useTable from "../components/useTable";

import axios from "axios";
import { Dimmer } from "../components/spinner";
import { DangerButton, SuccessButton } from "../ui/buttons/Button";
import { SearchInput } from "../ui/inputs/Input";
const headCells = [
  {
    id: "idorganizacion",
    label: "CODIGO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "nombre",
    label: "NOMBRE",
    width: "300px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];
const CatalogoOrganizacion = (props) => {
  /*  variables de estados */
  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [contar3] = useState(0);
  const [contar4, setContar4] = useState(0);
  const [activo, setActivo] = useState(true);
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idorganizacion.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.razonsocial.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };
  const handleCloseMensa = () => {
    setMostrar(false);
    if (contar3 > 0) {
      renderizar();
    }
  };
  /* metodo para cerrar el modal */
  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatOrg();
  };
  const renderizar = () => {
    seleccionarOrganizacionesTodas();
  };
  const seleccionarOrganizacionesTodas = () => {
    setContar4(0);
    let campos = "*";
    let nomtab = "organizacion";
    let condi = "true";
    let orden = "1";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var orga = [];
          for (let i = 0; i < response.data.length; i++) {
            orga.push({
              idorganizacion: response.data[i].idorganizacion,
              nombre: response.data[i].nombre,
              razonsocial: response.data[i].razonsocial,
              rif: response.data[i].rif,
            });
          }
          setRecords(orga);
          setContar4(contar4 + 1);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };
  const seleccionarLista = (index) => (event) => {
    blanquear();
    props.onHideAceptaCatOrg(
      values[0].idOrga,
      values[0].nomOrga,
      values[0].razosocOrga,
      values[0].rif
    );
  };
  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
    var idOrga = recordsAfterPagingAndSorting()[index].idorganizacion;
    var nomOrga = recordsAfterPagingAndSorting()[index].nombre;
    var razosocOrga = recordsAfterPagingAndSorting()[index].razonsocial;
    var rif = recordsAfterPagingAndSorting()[index].rif;
    var datos = [];
    datos.push({
      idOrga,
      nomOrga,
      razosocOrga,
      rif,
    });
    setValues(datos);
  };
  return (
    <Modal
      {...props}
      size="lg"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarOrganizacionesTodas();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <Modal.Title className="fs-4 fw-bold m-0 text-light">
          Seleccionar Organización.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-6 m-0 mb-2 p-0">
          <SearchInput
            onChange={handleSearch}
          />
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.idorganizacion}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "10px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.idorganizacion}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "600px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.nombre}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton disabled={activo} onClick={seleccionarLista()}>
          Aceptar
        </SuccessButton>
        <DangerButton ref={btnCancela} onClick={cancelar}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
export default CatalogoOrganizacion;
